import {client} from '@core/GraphQLProvider';
import {GetPaymetricAccessToken} from './query.graphql';

const TokenService = {
    async getPaymetricAccessToken () {
        const resp = await client.query( {
            fetchPolicy: 'no-cache',
            query: GetPaymetricAccessToken
        } );

        return resp.data.paymetricAccessToken;
    }
};

export default TokenService;
